import type { ReactNode } from "react"

export function isBrowserEnvironment(): boolean {
  return "window" in globalThis
}

export function isOpenStateUpdater(value: boolean | ((current: boolean) => boolean)): value is (current: boolean) => boolean {
  return Object.prototype.toString.call(value) === "[object Function]"
}

export function isStringTooltip(value: string | { children?: ReactNode }): value is string {
  return Object.prototype.toString.call(value) === "[object String]"
}
